import { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { isBackNavigationState } from '@/types/base/navigation';
import { AppRoutes } from '@/utils/constants';

// Forwards navigation context to the default tab. A plain <Navigate> would drop
// the incoming `state`, losing the `from` page label used by the "Back to ..."
// button, so we preserve it across the redirect.
const SalesIndexRedirect: FC = () => {
  const { state } = useLocation();

  const forwardedState = isBackNavigationState(state) ? { from: state.from } : undefined;

  return <Navigate to={AppRoutes.SALES_KEY_INDICATORS} replace state={forwardedState} />;
};

export default SalesIndexRedirect;
